import React from 'react'

export const ResumeIcon = ({ color = '#232323' }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      color={color}
    >
      <rect
        x='6.28571'
        y='5.90472'
        width='2.85714'
        height='12.5714'
        rx='1.42857'
        fill='currentColor'
      />
      <path
        d='M11.0476 6.75069C11.0476 6.10792 11.7945 5.75398 12.292 6.16101L18.7078 11.4103C19.0804 11.7152 19.0804 12.2849 18.7078 12.5897L12.292 17.839C11.7945 18.2461 11.0476 17.8921 11.0476 17.2494V6.75069Z'
        fill='currentColor'
      />
    </svg>
  )
}
